import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TriggersIcon extends BaseIcon {
  getChildren = () => [ <path
    fill={ this.getColor() }
    fillRule={ 'evenodd' }
    d='M16,8A8,8,0,1,1,8,0,8,8,0,0,1,16,8ZM12,8,6,12V4Z'/> ]
  getViewBox = () => '0 0 16 16'
}
